<div class="documents">
    <div
        class="doc-item"
        *ngFor="let doc of documents"
        [class.valid]="doc.status === 'VALID'"
        [class.missing]="doc.status === 'MISSING'"
    >
        <mat-icon class="doc-icon">{{ doc.icon }}</mat-icon>
        <h4>{{ doc.name }}</h4>
        <span class="status">
      {{ doc.status === 'VALID' ? 'En orden' : 'No disponible' }}
    </span>
    </div>
</div>
